/**
 * Computes national (electorate avg), constituency (selected electorate),
 * and selected-area (SA3/SA2) aggregates for the sidebar chart.
 *
 * national    — average across ALL electorate rows
 * constituency — the clicked electorate's row
 * selected    — the clicked SA3/SA2's row (from current level metricRows)
 */
export function getAggregatesForSidebar({
  metricRows,
  metricRowsElectorates,
  selectedFeature,
  selectedConstCode,
  group,
  waveSelect,
}) {
  const empty = { national: [], constituency: [], selected: [] };
  if (!group) return empty;

  const keys = group.keys || [];
  if (!keys.length) return empty;

  const filterByWave = (rows) =>
    waveSelect != null
      ? (rows || []).filter((r) => Number(r?.wave ?? r?.Wave) === Number(waveSelect))
      : (rows || []);

  const elecRows = filterByWave(metricRowsElectorates);
  const currRows = filterByWave(metricRows);

  const avg = (arr) => {
    const nums = (arr || []).map(Number).filter(Number.isFinite);
    return nums.length ? nums.reduce((a, b) => a + b, 0) / nums.length : null;
  };

  const matchId = (r, val) =>
    String(r?.area_id) === String(val) || String(r?.area_cd) === String(val);

  const collapse = (rows) =>
    keys.map((k) => ({ key: k, value: avg(rows.map((r) => r[k])) }));

  const national = elecRows.length ? collapse(elecRows) : [];

  const constituency =
    selectedConstCode != null && elecRows.length
      ? collapse(elecRows.filter((r) => matchId(r, selectedConstCode)))
      : [];

  const selected =
    selectedFeature?.value != null && currRows.length
      ? collapse(currRows.filter((r) => matchId(r, selectedFeature.value)))
      : [];

  return { national, constituency, selected };
}
